import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Entidad } from 'src/app/models/Entidad';
import { BusqEntidadComponent } from '../../general/busq-entidad/busq-entidad.component';
import { Denunciante } from 'src/app/models/Denunciante';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { Departamento } from 'src/app/models/Departamento';
import { Provincia } from 'src/app/models/Provincia';
import { Distrito } from 'src/app/models/Distrito';
import { codModoPresPropio, dscModoPresPropio, dscModoPresTraslado } from 'src/app/general/variables';
import { PersonaNaturalComponent } from '../PersonaNatural/persona-natural.component';
import { Persona } from 'src/app/models/Persona';

@Component({
  selector: 'app-dciante-entidad-pub',
  templateUrl: './dciante-entidad-pub.component.html',
  styleUrls: ['./dciante-entidad-pub.component.css']
})
export class DcianteEntidadPubComponent implements OnInit {

  // entidadFur:Entidad;

  denunciante: Denunciante = new Denunciante();
  departamentos: Departamento[] = [];
  provincias: Provincia[] = [];
  distritos: Distrito[] = [];
  flgLectura = false;
  flgPropio = false;
  dscModoPresPropio = dscModoPresPropio;
  dscModoPresTraslado = dscModoPresTraslado;

  @Output()  denunEntidadOut = new EventEmitter();
  @Output()  cambioTipoDocOut = new EventEmitter();


  @ViewChild(BusqEntidadComponent) busqEntidadC: BusqEntidadComponent;

  @ViewChild('pn1') personaNaturalC1: PersonaNaturalComponent;
  @ViewChild('pn2') personaNaturalC2: PersonaNaturalComponent;

  constructor(protected maestraService: MaestrasService) {
    this._setCodModoPresent(codModoPresPropio);
  }

  ngOnInit() {

    this.maestraService.obtenerDepartamentos().subscribe(data => {
      this.departamentos = data;
    });

  }

  _cambioTipoDocOut(numCaso: number) {

    // let flgEmite:boolean = false;

    // console.log("numCaso == 1 && this.flgPropio",numCaso ,this.flgPropio);

    // flgEmite = ((numCaso == 1 && this.flgPropio) || numCaso == 2);

    if (this._getEmitir(numCaso)) {

      this.cambioTipoDocOut.emit();

    }



  }

  _getEmitir(numCaso: number) {

    return ((numCaso == 1 && this.flgPropio) || numCaso == 2);

  }

  setModoLectura(flgValor: boolean) {

    this.flgLectura = flgValor;

    if (flgValor) {this.personaNaturalC1.personaNaturalCReadEnable(); } else {this.personaNaturalC1.personaNaturalCReadDisable(); }

    if (!this.flgPropio) {

      if (flgValor) {this.personaNaturalC2.personaNaturalCReadEnable(); } else {this.personaNaturalC2.personaNaturalCReadDisable(); }

    }

    this.busqEntidadC.setModoLectura(flgValor);

  }

  setDenunEntidadPub(denunciante: Denunciante) {

    this._setCodModoPresent(denunciante.cdenuncianteCodmodopresent);

    this.busqEntidadC.setEntidad(denunciante.cdenuncianteCodentcompl, false);


    if (this.flgPropio) {

      this.personaNaturalC1.setPersonaNaturalC(denunciante, 1);

    } else {

      this.personaNaturalC1.setPersonaNaturalC(denunciante, 2);

      setTimeout(() => {

        this.personaNaturalC2.setPersonaNaturalC(denunciante, 1);

      }, 1);

    }

    this.denunciante = denunciante;

  }

  getDenunEntidadPub() {

    let vPersona: Persona = null;
    let vPersonaCompl: Persona = null;

    if (this.flgPropio) {

      vPersona = this.personaNaturalC1.persona;



    } else {

      vPersona = this.personaNaturalC2.persona;

      vPersonaCompl = this.personaNaturalC1.persona;

    }

    this.denunciante.persona = vPersona;
    this.denunciante.personaComplemento = vPersonaCompl;

    return this.denunciante;


  }


  _setCodEntidadOut(entidadSelec: Entidad) {
    // this.entidadFur = entidadSelec;

    const vCodDep = entidadSelec.centDirdep;
    const vCodProv = entidadSelec.centDirpro;
    const vCodDist = entidadSelec.centDirdis;

    this.denunciante.cdenuncianteCdeptent = vCodDep;

    this.maestraService.obtenerProvincias(vCodDep).subscribe(data => {

      this.provincias = data;

      this.denunciante.cdenuncianteCprovent = vCodProv;

    });

    this.maestraService.obtenerDistritos(vCodDep, vCodProv).subscribe(data => {
        this.distritos = data;
        this.denunciante.cdenuncianteCdistent = vCodDist;
    });

    this.denunciante.cdenuncianteDscdireccent = entidadSelec.centDirecc;

    // this.denunciante.cdenuncianteDscrefcent = entidadSelec.centDirRef;
    this.denunciante.cdenuncianteCodentcompl = entidadSelec.centCodigo;

  }

  getDcPersComponent() {

    return  (this.flgPropio ? this.personaNaturalC1 : this.personaNaturalC2) ;

  }


  // _obtenerProvincias(codDep : string){
  //   this.maestraService.obtenerProvincias(codDep).subscribe(data =>{
  //       this.provincias = data;
  //   });
  // }

  // _obtenerDistritos(codDep : string , codProv : string){
  //   this.maestraService.obtenerDistritos(codDep,codProv).subscribe(data =>
  //     {
  //         this.distritos = data;
  //     });
  // }

  _setCodModoPresent(codModo: string) {

    this._setPersonaOtroOut(null, 1, true);
    this._setPersonaOtroOut(null, 2, true);

    this.denunciante.cdenuncianteCodmodopresent = codModo;

    this.flgPropio = (codModo == codModoPresPropio);

  }

  _datosComplementOut(persona: Persona, numCaso: number) {

    if (this._getEmitir(numCaso)) {

      this.denunEntidadOut.emit(persona);

    }



  }

  _setPersonaOtroOut(data: Persona, numCaso: number, flgReset: boolean) {

    let vPersonaNatC: PersonaNaturalComponent = null;
    let vPersonaNatCReset: PersonaNaturalComponent = null;
    const vPersonaNatC1: PersonaNaturalComponent = this.personaNaturalC1;
    const vPersonaNatC2: PersonaNaturalComponent = this.personaNaturalC2;

    vPersonaNatC = (numCaso == 1 ? vPersonaNatC2 : vPersonaNatC1);

    if (flgReset) {

      vPersonaNatCReset = (numCaso == 1 ? vPersonaNatC1 : vPersonaNatC2);

      if (vPersonaNatCReset != null) {vPersonaNatCReset.resetPersonaNaturalC(); }

    }

    if (vPersonaNatC != null) {

      vPersonaNatC.setPersonaOtro(data);

    }

  }

  _cambioModo(codModo: string) {

    // console.log("=======0codModo");
    // console.log(codModo);

    this._setCodModoPresent(codModo);

    setTimeout(() => {

      this.personaNaturalC1.setTipDocumentPn(1);

      if (!this.flgPropio) {

        this.personaNaturalC2.setTipDocumentPn(1);

      }

    }, 50);

  }

}
